import React, { useEffect, useState } from 'react'
import { CCol, CForm, CFormInput, CFormLabel, CFormTextarea, CRow } from '@coreui/react'
import { Button } from '@mui/material'
import { Icon } from '@iconify/react'
import { Card } from 'primereact/card'
import { Dialog } from 'primereact/dialog'
import { Checkbox } from 'primereact/checkbox'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { useRestaurant } from '../contexts/RestaurantContext'
import { useAuth } from '../contexts/AuthContext'
import UpdatePin from './UpdatePin'
import CInput from './CInput'

function AddRestaurant({ editMode, editRestaurantId, visible, fetchRestaurants, handleClose }) {
    const { getSingleRestaurant, createRestaurant, updateRestaurant, updateRestaurantPin } = useRestaurant()
    const { toast } = useAuth()

    const [validated, setValidated] = useState(false);
    const [pinValidated, setPinValidated] = useState(false);
    const [changePinVisible, setChangePinVisible] = useState(false)
    const [changePinCredential, setChangePinCredential] = useState({
        newPin: "",
        confirmNewPin: ""
    })
    const [restaurantDetail, setRestaurantDetail] = useState({
        name: "",
        address: "",
        pin: "",
        registration_number: "",
        vat_number: "",
        exo_number: "",
        table_time: "",
        logo: "",
        isActive: true,
        validation_code: "",
        sales_target: 500
    })

    const fetchSingleRestaurant = async () => {
        try {
            const restaurant = await getSingleRestaurant(editRestaurantId);
            setRestaurantDetail({ ...restaurant, isActive: restaurant.isActive === 1 ? true : false });
        } catch (error) {
            console.error('Error fetching single restaurant', error);
        }
    };

    useEffect(() => {
        if (editMode && editRestaurantId) fetchSingleRestaurant();
    }, [editMode, editRestaurantId]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        setValidated(true);

        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                if (visible) {
                    const data = await createRestaurant({ ...restaurantDetail, isActive: restaurantDetail.isActive ? 1 : 0 });
                    if (!data.error) {
                        handleClose();
                        setRestaurantDetail({
                            name: "",
                            address: "",
                            pin: "",
                            registration_number: "",
                            vat_number: "",
                            exo_number: "",
                            logo: "",
                            isActive: false,
                            validation_code: "",
                            table_time: "",
                            sales_target: 500
                        })
                        fetchRestaurants()
                    }
                } else if (editMode && editRestaurantId) {
                    const data = await updateRestaurant(editRestaurantId, { ...restaurantDetail, isActive: restaurantDetail.isActive ? 1 : 0 });
                    if (!data.error) {
                        handleClose();
                        setRestaurantDetail({
                            name: "",
                            address: "",
                            pin: "",
                            registration_number: "",
                            vat_number: "",
                            exo_number: "",
                            logo: "",
                            isActive: false,
                            validation_code: "",
                            table_time: "",
                            sales_target: 500
                        })
                        fetchRestaurants()
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    const handleUpdatePin = async (e) => {
        e.preventDefault()
        const form = e.currentTarget;

        if (changePinVisible) {
            setPinValidated(true)
        }

        if (form.checkValidity() === false) {
            e.stopPropagation();
            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                if (changePinVisible) {
                    if (changePinCredential.newPin !== changePinCredential.confirmNewPin) {
                        toast.current.show({ severity: 'error', summary: 'Restaurant', detail: "New Pin and Confirm New Pin must be same", life: 3000 })
                    } else {
                        const data = await updateRestaurantPin(editRestaurantId, changePinCredential.newPin)
                        if (!data.error) {
                            handleClosePinPopPop()
                        }
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    const handleClosePinPopPop = () => {
        setChangePinVisible(false)
        setChangePinCredential({
            newPin: "",
            confirmNewPin: ""
        })
        setPinValidated(false)
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        const fileInput = e.target;
    
        if (file) {
            const img = new Image();
            const reader = new FileReader();
    
            reader.onloadend = () => {
                img.onload = () => {
                    if (img.width > 512 || img.height > 512) {
                        toast.current.show({
                            severity: 'error',
                            summary: 'Invalid Logo',
                            detail: 'Image dimensions should not exceed 512x512 pixels.',
                            life: 3000,
                        });

                        fileInput.value = '';
                        return;
                    } else {
                        setRestaurantDetail({ ...restaurantDetail, logo: reader.result });
                    }
                };
    
                img.onerror = () => {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Invalid Logo',
                        detail: 'Unable to load the image.',
                        life: 3000,
                    });
                    fileInput.value = '';
                };
    
                img.src = reader.result;
            };
    
            reader.readAsDataURL(file);
        }
    };

    return (
        <div>
            {
                changePinVisible && (
                    <Dialog draggable={false} header={'Change PIN'} visible={changePinVisible} style={{ width: '20vw' }} onHide={handleClosePinPopPop}>
                        <CForm onSubmit={handleUpdatePin} noValidate validated={pinValidated}>
                            <UpdatePin
                                changePinCredential={changePinCredential}
                                setChangePinCredential={setChangePinCredential}
                            />
                            <div className={`d-flex justify-content-end mt-4 button-container`}>
                                <div className='d-flex'>
                                    <Button onClick={handleClosePinPopPop} fullWidth variant="contained" color="inherit" >
                                        Cancel
                                    </Button>
                                    <Button fullWidth variant="contained" color='primary' type="submit" className='ms-3'>
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </CForm>
                    </Dialog>
                )
            }
            {(visible || (editMode && editRestaurantId)) && (
                <Dialog draggable={false} header={`${visible ? 'Create Restaurant' : 'Edit Restaurant'}`} visible={visible || (editMode && editRestaurantId !== null)} style={{ width: '30vw' }} onHide={handleClose}>
                    <CForm onSubmit={handleSubmit} noValidate validated={validated}>
                        <div className='fields-container'>
                            <CRow className="mb-3 mt-3">
                                <CInput
                                    label="Name"
                                    type="text"
                                    value={restaurantDetail.name}
                                    onChange={(value) => setRestaurantDetail({ ...restaurantDetail, name: value })}
                                    required={true}
                                    errorMessage='Name is required.'
                                />
                            </CRow>
                            <CRow className='mb-3'>
                                {visible ?
                                    (
                                        <div>
                                            <div>
                                                <CFormLabel>PIN <span className="text-danger">*</span></CFormLabel>
                                            </div>
                                            <div className='w-100'>
                                                <CFormInput
                                                    type='password'
                                                    pattern='\d*'
                                                    minLength={4}
                                                    maxLength={4}
                                                    value={restaurantDetail.pin}
                                                    onChange={(e) => setRestaurantDetail({ ...restaurantDetail, pin: e.target.value })}
                                                    required
                                                    feedbackInvalid='Please enter 4 digit PIN.'
                                                    className='is_not_validated'
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <CFormLabel>PIN</CFormLabel>
                                            <Button fullWidth variant="contained" color="inherit" onClick={() => setChangePinVisible(true)}>
                                                Change PIN
                                            </Button>
                                        </div>
                                    )
                                }
                            </CRow>
                            <CRow className="mb-3 mt-3">
                                <CInput
                                    label="Validation code"
                                    type="text"
                                    value={restaurantDetail.validation_code}
                                    onChange={(value) => setRestaurantDetail({ ...restaurantDetail, validation_code: value })}
                                    required={true}
                                    errorMessage='Validation code is required.'
                                />
                            </CRow>
                            <CRow className="mb-3">
                                <div>
                                    <CFormLabel className='w-50 custom-word-break'>Address <span className="text-danger">*</span></CFormLabel>
                                    <CFormTextarea
                                        rows={3}
                                        value={restaurantDetail.address}
                                        onChange={(e) => setRestaurantDetail({ ...restaurantDetail, address: e.target.value })}
                                        required
                                        feedbackInvalid='Address is required.'
                                    />
                                </div>
                            </CRow>
                            <CRow className="mb-3 mt-3">
                                <CInput
                                    label="Registration number"
                                    type="text"
                                    value={restaurantDetail.registration_number}
                                    onChange={(value) => setRestaurantDetail({ ...restaurantDetail, registration_number: value })}
                                    required={true}
                                    errorMessage='Registration number is required.'
                                />
                            </CRow>
                            <CRow className="mb-3 mt-3">
                                <CInput
                                    label="Vat number"
                                    type="text"
                                    value={restaurantDetail.vat_number}
                                    onChange={(value) => setRestaurantDetail({ ...restaurantDetail, vat_number: value })}
                                    required={true}
                                    errorMessage='Vat number is required.'
                                />
                            </CRow>
                            <CRow className="mb-3 mt-3">
                                <CInput
                                    label="EXO number"
                                    type="text"
                                    value={restaurantDetail.exo_number}
                                    onChange={(value) => setRestaurantDetail({ ...restaurantDetail, exo_number: value })}
                                    errorMessage='EXO number is required.'
                                />
                            </CRow>
                            <CRow className="mb-3 mt-3">
                                <CInput
                                    label="Table time(In Minutes)"
                                    type="number"
                                    value={restaurantDetail.table_time}
                                    onChange={(value) => setRestaurantDetail({ ...restaurantDetail, table_time: value })}
                                    required={true}
                                    errorMessage='Table time is required.'
                                />
                            </CRow>
                            <CRow className="mb-3 mt-3">
                                <div lg={4}>
                                    <CFormLabel className="form-label w-55">Sales Target <span className="text-danger">*</span></CFormLabel>
                                </div>
                                <div lg={8}>
                                    <CFormInput
                                        type="number"
                                        step="any"
                                        min={1}
                                        value={restaurantDetail.sales_target}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            if (newValue >= 0) {
                                                setRestaurantDetail({ ...restaurantDetail, sales_target: newValue })
                                            }
                                        }}
                                        required
                                        feedbackInvalid='Sales Target should be greater than 0.'
                                    />
                                </div>
                            </CRow>
                            <CRow className="mb-3">
                                <CFormLabel>Logo</CFormLabel>
                                <CCol style={{ position: 'relative' }}>
                                    <input type="file" accept="image/*" onChange={handleImageChange} style={{ display: 'none' }} id="fileInput" />
                                    <label htmlFor="fileInput">
                                        <Card
                                            className="create-card"
                                            header={restaurantDetail.logo ? <LazyLoadImage src={restaurantDetail.logo || 'defaultImageURL'} alt="Restaturant" className='create-img' /> :
                                                <Icon icon="material-symbols:imagesmode-outline-rounded" style={{ color: 'black' }} height={100} width={100} />}
                                        />
                                    </label>
                                    {
                                        restaurantDetail.logo &&
                                        <Icon
                                            icon="mdi:close"
                                            className='close-btn'
                                            height={15}
                                            width={15}
                                            onClick={() => setRestaurantDetail({ ...restaurantDetail, logo: '' })}
                                        />
                                    }
                                </CCol>
                            </CRow>
                            <CRow className='mb-3'>
                                <div className='d-flex'>
                                    <CFormLabel className="form-label me-2">Active</CFormLabel>
                                    <Checkbox
                                        checked={restaurantDetail.isActive}
                                        onChange={(event) => setRestaurantDetail({ ...restaurantDetail, isActive: event.target.checked })}
                                    />
                                </div>
                            </CRow>
                        </div>
                        <div className="d-flex p-jc-end justify-content-end button-container">
                            <div className='d-flex'>
                                <Button onClick={handleClose} fullWidth variant="contained" color="inherit" >
                                    Cancel
                                </Button>
                                <Button fullWidth variant="contained" color='primary' type="submit" className='ms-3'>
                                    Submit
                                </Button>
                            </div>
                        </div>
                    </CForm>
                </Dialog>
            )}
        </div>
    )
}

export default AddRestaurant;
